const WISHLIST_KEY = 'theme_wishlist';

class Wishlist {
  constructor() { this.items = this.load(); }
  load() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch { return []; }
  }
  save(action) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(this.items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: this.items, action } }));
  }
  has(handle) { return this.items.some(i => i.handle === handle); }
  add(item) { if (!this.has(item.handle)) { this.items.push(item); this.save('added'); } }
  remove(handle) { this.items = this.items.filter(i => i.handle !== handle); this.save('removed'); }
  toggle(item) { this.has(item.handle) ? this.remove(item.handle) : this.add(item); return this.has(item.handle); }
  count() { return this.items.length; }
  all() { return this.items; }
}

window.wishlist = new Wishlist();

function syncWishlistUI() {
  /* Badge counts (header, drawer, etc.) */
  document.querySelectorAll('[data-wishlist-count]').forEach(el => {
    const c = window.wishlist.count();
    el.textContent = c;
    el.hidden = c === 0;
  });

  /* Heart toggle buttons — the handle lives in data-wishlist-toggle's VALUE.
     e.g. <button data-wishlist-toggle="product-handle" ...> */
  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    const handle = btn.dataset.wishlistToggle;
    if (!handle) return; /* skip if attribute has no value */
    const active = window.wishlist.has(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active);
  });
}

function renderWishlistPage() {
  const grid = document.querySelector('[data-wishlist-grid]');
  if (!grid) return;
  const empty = document.querySelector('[data-wishlist-empty]');
  const items = window.wishlist.all();
  if (empty) empty.hidden = items.length > 0;
  grid.innerHTML = items.map(i => `
    <div class="wishlist-card">
      <a href="${i.url}" class="wishlist-card__link">
        <img src="${i.image}" alt="${i.title}" loading="lazy" width="300">
        <h3 class="wishlist-card__title">${i.title}</h3>
        <p class="wishlist-card__price">${i.price}</p>
      </a>
      <button type="button" class="wishlist-card__remove is-active" data-wishlist-toggle="${i.handle}" data-product-id="${i.id}" data-product-title="${i.title}" data-product-image="${i.image}" data-product-price="${i.price}" data-product-url="${i.url}">Remove</button>
    </div>
  `).join('');
}

let wishlistToastTimer;
function showWishlistToast(msg) {
  let toast = document.querySelector('[data-wishlist-toast]');
  if (!toast) {
    toast = document.createElement('div');
    toast.setAttribute('data-wishlist-toast', '');
    toast.className = 'wishlist-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.classList.add('is-visible');
  clearTimeout(wishlistToastTimer);
  wishlistToastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
}

document.addEventListener('wishlist:updated', (e) => {
  syncWishlistUI();
  renderWishlistPage();
  if (e.detail.action === 'added') showWishlistToast('Added to wishlist');
  if (e.detail.action === 'removed') showWishlistToast('Removed from wishlist');
});

document.addEventListener('DOMContentLoaded', () => { syncWishlistUI(); renderWishlistPage(); });

/* Delegate all wishlist toggle clicks.
   The product handle is in data-wishlist-toggle="<handle>".
   All other product data lives on data-product-* attributes. */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn) return;
  e.preventDefault();

  const handle = btn.dataset.wishlistToggle;
  if (!handle) return;

  window.wishlist.toggle({
    handle: handle,
    id: btn.dataset.productId,
    title: btn.dataset.productTitle,
    image: btn.dataset.productImage,
    price: btn.dataset.productPrice,
    url: btn.dataset.productUrl,
  });
});
